import React, { useEffect, useState } from "react";
import { useAuth } from "../../../AuthenticationStore";
import "semantic-ui-css/semantic.min.css";
import { Switch, Redirect, useHistory } from "react-router-dom";

import { PrivateRoute } from "../../../components/PrivateRoute";

import NavBar from "../../../components/ui/navbar";

// configuration section
import { Configuration } from "../configuration";
// campaigns section
import Campaigns from "../campaigns/Campaigns";
import CampaignsNew from "../campaigns/New";
import CampaignDashboard from "../campaigns/CampaignDashboard";
// indicators section
import Indicators from "../Indicators";
// admin site
import Administrator from "../Administrator";

export const Home = () => {
  const { loading, userContext } = useAuth();
  const [roleAdmin, setRoleAdmin] = useState(false);
  let history = useHistory();

  useEffect(() => {
    if (userContext) {
      const filterRoutesAdmin = userContext.roleMap.filter(el => el.platformRoute === "/admin")
      if(filterRoutesAdmin.length === 0)
        setRoleAdmin(false);
      else
        setRoleAdmin(true);
    }
  },[userContext, history])


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-scroller">
      <NavBar />
      <div className="container-fluid page-body-wrapper">
        <div
          style={{
            background: process.env.REACT_APP_SANDBOX? "url("+process.env.PUBLIC_URL+"/vendors/img/demo/demo_back.png)" : null
          }}
          className="main-panel"
        >
          <div className="content-wrapper">
            <div className="row">
              <div className="col-12 grid-margin stretch-card">
                <Switch>
                  <Redirect exact from="/" to="indicators" />
                  {/* campaigns */}
                  <PrivateRoute exact path="/campaigns" component={Campaigns} />
                  <PrivateRoute
                    path="/campaigns/new"
                    component={CampaignsNew}
                  />
                  <PrivateRoute
                    path="/campaigns/configure/:campaignId"
                    component={CampaignsNew}
                  />

                  {/* indicators */}
                  <PrivateRoute
                    exact
                    path="/indicators"
                    component={Indicators}
                  />
                  <PrivateRoute
                    exact
                    path="/indicators/:campaignId"
                    component={CampaignDashboard}
                  />

                  {/* configurations */}
                  <PrivateRoute
                    path="/configuration"
                    component={Configuration}
                  />

                  {/* admin site roles */}
                  {roleAdmin?
                    <PrivateRoute path="/admin" component={Administrator} /> 
                    :
                    <Redirect to="/" />
                  }
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
